<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="cms.icon" class="mr-1"></i>
            <span>{{ cms.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Container" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="name" :debounce="cms.debounce" placeholder="Container" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!name" @click="name = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="cms" :icon="cms.icon" :busy="cms.busy"
            :toolbarlibrary="cms.toolbarlibrary" :tools="cms.tools" :badges="cms.badges" :fields="cms.fields"
            :items="cms.items" :offset="cms.offset" :limit="cms.limit" :page="cms.page" @load="cms_load"
            @click="cms_click" @changed="cms_click('save', $event)" @select="cms_select">
          </d-table>
        </div>
      </div>

      <!-- @go="cms_click('go')" -->
      <div v-show="component">
        <component :is="component" :selection="cms.selected" :config="cconfig" @discard="cms_click('discard')">
        </component>
      </div>
    </b-card>
  </div>
</template>
    
    
<script>
import gql from "graphql-tag";

import CMSEdit from "./Components/CMSEdit";

export default {
  name: "CMS",
  components: { CMSEdit },
  watch: {
    async name() {
      await this.cms_load(0);
    },
  },
  data() {
    return {
      name: null,
      cms: {
        title: "CMS",
        icon: "fa fa-list",
        debounce: 500,
        busy: false,
        denied: [],
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,export,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },
          {
            key: "id",
            label: "Parent ID",
            sortable: true,
            class: "text-left",
          },

          {
            key: "name",
            label: "Container",
            sortable: true,
            class: "text-left",
          },
          {
            key: "type",
            label: "Type",
            sortable: true,
            class: "text-left",
          },
          {
            key: "category",
            label: "Category",
            sortable: true,
            class: "text-left",
          },
          {
            key: "style",
            label: "Style",
            sortable: true,
            class: "text-left",
          },
          {
            key: "sort",
            label: "Sort",
            sortable: true,
            class: "text-left",
          },
          {
            key: "state",
            label: "State",
            sortable: true,
            class: "text-left",
          },
          {
            key: "data",
            label: "Content",
            sortable: true,
            class: "text-left",
          },
          {
            key: "approved_by",
            label: "Approved By",
            sortable: true,
          },
          {
            key: "approved_at",
            label: "Approved At",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          // {
          //   key: "category",
          //   type: "pill",
          //   class: "white",
          // },
          {
            key: "category",
            type: "badge",
            "Carbon": "dark",
            "Component": "info",
            formatter: (value, key, item) => {
              switch (value) {
                case "component":
                  return "Component";
                  break;
                case "carbon":
                  return "Carbon";
                  break;
                default:
                  return value;
              }
            },
          },

          {
            key: "type",
            type: "badge",
            "Card Group": "success",
            "Card": "warning",
            formatter: (value, key, item) => {
              switch (value) {
                case "b-card-group":
                  return "Card Group";
                  break;
                case "b-card":
                  return "Card";
                  break;
                default:
                  return value;
              }
            },
          },
        ],
        items: [],
        selected: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();
    await this.cms_load();
  },

  methods: {
    accessdenied() {
      this.cms.denied = [];
      if (!this.user.permissions.includes("cms.delete")) {
        this.cms.denied.push("deleteconfirm");
      }
    },
    async cms_load(offset, limit, page) {

      let state = this.cms;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        name: this.name,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
                        query container($name: String) {
                            container(name: $name) {
                                id
                                name
                                type
                                category
                                style
                                data     
                                state
                                parent_id
                                updated_at
                                updated_by
                                approved_at
                                approved_by
                                elements {
                                    id
                                    label
                                    name
                                    data
                                    type
                                    category
                                    style
                                    state
                                    sort
                                    updated_at
                                    updated_by
                                    approved_at
                                    approved_by
                                }    
                            }
                        }
                        `,
          variables: { name },
        });

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.container
        } else {
          state.items = []
          state.items = response.data.container;
        }


      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async cms_click(a, ss) {

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          break;
        case "go":
          this.component = null;
          this.cms_load();
          break;
        case "add":
        case "edit":
          this.component = "CMSEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async cms_select(ss, tools) {

      let state = this.cms;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "export"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {
      // let requirement = { ...this.requirement_bookerinitial };


      // let requirements = "";
      // for (var prop in requirement) {
      //   if (this.item[prop] == null) {
      //     requirements += requirement[prop] + ", ";
      //     // break;
      //   }
      // }
      // if (requirements.length > 0) {
      //   this.message =
      //     "<span class='text-danger'>" +
      //     requirements.slice(0, -1) +
      //     " required field(s). </span>";
      //   return;
      // }
      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation container_save($rows: [Container_input]) {
                container_save(rows: $rows) {
                  id
                            name
                            type
                            category
                            style
                            data
                            state
                            sort
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation container_delete($rows: [Container_input]) {
                container_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.cms_load(0);
    },
  },
};
</script>
    
<style></style>